export const LIST_MCU_PROJECT_CRS_REQUEST = 'LIST_MCU_PROJECT_CRS_REQUEST'
export const LIST_MCU_PROJECT_CRS_SUCCESS = 'LIST_MCU_PROJECT_CRS_SUCCESS'
export const LIST_MCU_PROJECT_CRS_FAIL = 'LIST_MCU_PROJECT_CRS_FAIL'

export const LIST_MCU_PROJECT_CRS_SUMMARY_REQUEST = 'LIST_MCU_PROJECT_CRS_SUMMARY_REQUEST'
export const LIST_MCU_PROJECT_CRS_SUMMARY_SUCCESS = 'LIST_MCU_PROJECT_CRS_SUMMARY_SUCCESS'
export const LIST_MCU_PROJECT_CRS_SUMMARY_FAIL = 'LIST_MCU_PROJECT_CRS_SUMMARY_FAIL'

export const CREATE_MCU_PROJECT_CRS_REQUEST = 'CREATE_MCU_PROJECT_CRS_REQUEST'
export const CREATE_MCU_PROJECT_CRS_SUCCESS = 'CREATE_MCU_PROJECT_CRS_SUCCESS'
export const CREATE_MCU_PROJECT_CRS_FAIL = 'CREATE_MCU_PROJECT_CRS_FAIL'

export const DETAIL_MCU_PROJECT_CRS_REQUEST = 'DETAIL_MCU_PROJECT_CRS_REQUEST'
export const DETAIL_MCU_PROJECT_CRS_SUCCESS = 'DETAIL_MCU_PROJECT_CRS_SUCCESS'
export const DETAIL_MCU_PROJECT_CRS_FAIL = 'DETAIL_MCU_PROJECT_CRS_FAIL'

export const UPDATE_MCU_PROJECT_CRS_REQUEST = 'UPDATE_MCU_PROJECT_CRS_REQUEST'
export const UPDATE_MCU_PROJECT_CRS_SUCCESS = 'UPDATE_MCU_PROJECT_CRS_SUCCESS'
export const UPDATE_MCU_PROJECT_CRS_FAIL = 'UPDATE_MCU_PROJECT_CRS_FAIL'

export const DELETE_MCU_PROJECT_CRS_REQUEST = 'DELETE_MCU_PROJECT_CRS_REQUEST'
export const DELETE_MCU_PROJECT_CRS_SUCCESS = 'DELETE_MCU_PROJECT_CRS_SUCCESS'
export const DELETE_MCU_PROJECT_CRS_FAIL = 'DELETE_MCU_PROJECT_CRS_FAIL'

export const RESET_MCU_PROJECT_CRS = 'RESET_MCU_PROJECT_CRS'
